import React from "react";
import PointOfSaleCore from "../../components/PointOfSale/Core/index";
import SupermarketEstimate from "./SupermarketEstimate";
import ModuleGate from "../ModuleGate";

const Estimate = () => (
  <ModuleGate module="estimate">
    <PointOfSaleCore component={SupermarketEstimate} />
  </ModuleGate>
);

export default Estimate;
